<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs>
            <!-- 参数设置 -->
            <el-tab-pane>
                <span slot="label"> {{ $t("logs.smartLearn1") }}</span>
                <div class="lie">
                    <table>
                        <tbody>
                            <tr>
                                <!-- 启用智能学习过滤 -->

                                <td>{{ $t("logs.url_a2") }}:</td>
                                <td style="display:flex;flex-direction:row;">
                                    <el-checkbox-group v-model="url_isolate_on">
                                        <el-checkbox label=""></el-checkbox>
                                    </el-checkbox-group>
                                    <el-alert :title="this.show_hint1" type="warning" show-icon :closable="false" style="margin-left:10px"></el-alert>
                                </td>
                            </tr>
                            <tr>
                                <!-- 智能学习最大邮件大小(KB) -->

                                <td>{{ $t("logs.url_a3") }}:</td>
                                <td style="display:flex;flex-direction:row;">
                                    <el-input v-model="url_isolate_add_url" placeholder=""></el-input>
                                    <el-alert :title="this.show_hint2" type="warning" show-icon :closable="false" style="margin-left:10px"></el-alert>
                                </td>
                            </tr>

                            <tr></tr>
                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="save_set()" :disabled="$root.jurisdiction.only_query==0">{{$t('logs.save_a')}}</el-button>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
            <!-- 个性化设置 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.smartLearn2") }}</span>
                <div class="main  maina-a">
                    <p>
                        <span class="main_text"> {{ $t("logs.url_a5") }}:</span>
                        <el-select v-model="defaut_pol" placeholder="请选择">
                            <el-option v-for="item in defaut_pol_arr" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        <el-button @click="save_defaut()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.save_a") }}</el-button>
                        <el-button @click="tan_filter()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.Conditional7") }}</el-button>
                        <el-alert :title="this.show_hint4" type="warning" show-icon :closable="false"></el-alert>
                    </p>

                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList1" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="100"> </el-table-column>
                            <el-table-column prop="EMAIL" :label="$t('logs.smartLearn8')"> </el-table-column>
                            <el-table-column prop="SHOW_TYPE" :label="$t('logs.smtpIp6')"> </el-table-column>
                            <el-table-column prop="SHOW_ACTION" :label="$t('logs.Policy_list13')"> </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')">
                                <template scope="scope">
                                    <!-- 删除 -->
                                    <el-button @click="del_ip(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_cert_domain' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_cert_domain"><span class="span_pad"></span> {{$t('logs.Conditional7')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.smartLearn8") }}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="emailorip" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 类型 -->

                                    {{ $t("logs.smtpIp6") }} :
                                </div>
                                <div class="block block1">
                                    <el-select v-model="type" placeholder="请选择">
                                        <el-option v-for="item in type_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 类型 -->

                                    {{ $t("logs.manage4") }} :
                                </div>
                                <div class="block block1">
                                    <el-select v-model="action" placeholder="请选择">
                                        <el-option v-for="item in action_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_ip()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_ip()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                    <div class="pop-up" v-show="tanchu_edit" v-drag="{ handle: '.pop_up_text_relay_domain' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_relay_domain"><span class="span_pad"></span> {{$t('logs.Conditional7')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    Email:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="email" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 类型 -->

                                    {{ $t("logs.smtpIp6") }} :
                                </div>
                                <div class="block block1">
                                    <el-select v-model="type" placeholder="请选择">
                                        <el-option v-for="item in type_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_edit_ip()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_edit_ip()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_edit"></div>
                </div>
            </el-tab-pane>
            <!-- 个性化设置 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.url_a1") }}</span>
                <div class="main  maina-a">
                    <p>

                        <el-button @click="tan_url()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.Conditional7") }}</el-button>
                        <el-alert :title="this.show_hint5" type="warning" show-icon :closable="false"></el-alert>
                    </p>

                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList2" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="100"> </el-table-column>
                            <el-table-column prop="URLORIP" :label="$t('logs.url_a4')"> </el-table-column>

                            <el-table-column prop="address" :label="$t('logs.audit6')">
                                <template scope="scope">
                                    <!-- 删除 -->
                                    <el-button @click="del_ip1(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu"  v-drag="{ handle: '.pop_up_text_relay_domain_edit' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_relay_domain_edit"><span class="span_pad"></span> {{$t('logs.Conditional7')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.Policy_unit_ip1") }}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="urlorip" placeholder=""></el-input>
                                </div>
                            </div>

                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_url()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_ip()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                    <div class="pop-up" v-show="tanchu_edit" v-drag>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    Email:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="email" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 类型 -->

                                    {{ $t("logs.smtpIp6") }} :
                                </div>
                                <div class="block block1">
                                    <el-select v-model="type" placeholder="请选择">
                                        <el-option v-for="item in type_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_edit_ip()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_edit_ip()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_edit"></div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            urlorip: '',
            emailorip: '',
            url_isolate_on: '',
            url_isolate_add_url: '',
            action: 1,
            action_arr: [],
            show_hint1: '',
            show_hint2: '',
            show_hint3: '',
            show_hint4: '',
            show_hint5: '',
            tanchu_edit: false,
            defaut_pol_arr: [],
            defaut_pol: '',
            type: 0,
            type_arr: [],
            ipaddr: '',
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44",
            }, ],
            email: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS",
                },
                {
                    value: "选项2",
                    label: "增加信头标记",
                },
                {
                    value: "选项3",
                    label: "强制TLS",
                },
            ],
            checked: "",
            fileList1: [],
            fileList2: [],
            radio: [],
            data_loadok1: '',
        };
    },
    mounted() {
        this.getFileList1()
        this.getFileList2()
        this.getFileList3()

    },
    methods: {
        save_edit_ip() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            let str = this.$qs.stringify({
                __mode: "save_authemail",
                sid: sid,
                type: this.type,
                email: this.email,
                newadd: 0

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu_edit = false

                        this.getFileList1()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        del_ip1(index, row) {
            // console.log(index, row)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    // console.log(sid);
                    let str = this.$qs.stringify({
                        __mode: "del_url_isolate_white",
                        sid: sid,

                        urlorip: row.URLORIP

                    });
                    this.$axios
                        .post("/api/adm/cgi/aspam.cgi", str)
                        .then((res) => {
                            // console.log(res)
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.getFileList3()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
        del_ip(index, row) {
            // console.log(index, row)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    // console.log(sid);
                    let str = this.$qs.stringify({
                        __mode: "del_url_isolate_person",
                        sid: sid,

                        emailorip: row.EMAIL

                    });
                    this.$axios
                        .post("/api/adm/cgi/aspam.cgi", str)
                        .then((res) => {
                            // console.log(res)
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.getFileList2()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
        save_url() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            let str = this.$qs.stringify({
                __mode: "save_url_isolate_white",
                sid: sid,

                urlorip: this.urlorip,

            });
            this.$axios
                .post("/api/adm/cgi/aspam.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false

                        this.getFileList3()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        save_ip() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            let str = this.$qs.stringify({
                __mode: "save_url_isolate_person",
                sid: sid,

                type: this.type,
                action: this.action,
                newadd: 1,
                emailorip: this.emailorip,

            });
            this.$axios
                .post("/api/adm/cgi/aspam.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false

                        this.getFileList2()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        edit_ip(index, row) {
            console.log(index, row)
            // this.email = row.EMAIL
            // this.type = row.VALUE

            this.tanchu_edit = true

        },
        tan_url() {
            this.tanchu = true
            this.urlorip = ''

        },
        off_edit_ip() {
            this.tanchu_edit = false
        },
        tan_filter() {
            this.tanchu = true
            this.emailorip = ''
        },
        off_ip() {
            this.tanchu = false

        },
        save_defaut() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/aspam.cgi", {
                    params: {
                        __mode: "save_url_isolatechk_dft_pol",
                        sid: sid,
                        defaut_pol: this.defaut_pol
                    },
                })
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.getFileList2()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        // 参数设置保存
        save_set() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/aspam.cgi", {
                    params: {
                        __mode: "save_url_isolate_param",
                        sid: sid,
                        url_isolate_on: this.url_isolate_on == true ? 1 : 0,
                        url_isolate_add_url: this.url_isolate_add_url,
                        data_loadok: this.data_loadok1
                    },
                })
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.getFileList1()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        // 过滤单元加载
        getFileList3() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/aspam.cgi", {
                    params: {
                        __mode: "load_url_isolate_white",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);

                    if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                       this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;

                        this.fileList2 = res.data.ret.datalist

                        this.show_hint5 = res.data.ret.LOAD_HINT

                    }
                })
               
        },
        // 过滤单元加载
        getFileList2() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/aspam.cgi", {
                    params: {
                        __mode: "load_url_isolate_person",
                        sid: sid,
                    },
                })
                .then((res) => {
                    console.log(res);

                    if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;

                        this.fileList1 = res.data.ret.datalist

                        this.show_hint4 = res.data.ret.LOAD_HINT2
                        this.defaut_pol_arr = res.data.ret.q_defaut_pol
                        this.type_arr = res.data.ret.q_type
                        this.action_arr = res.data.ret.q_action
                        this.defaut_pol = res.data.ret.DEFAULT_POL

                    }
                })
               
        },
        // 过滤单元加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/aspam.cgi", {
                    params: {
                        __mode: "load_url_isolate_param",
                        sid: sid,
                    },
                })
                .then((res) => {
                    console.log(res);

                   if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;

                        this.url_isolate_on = res.data.ret.result.url_isolate_on == 1 ? true : false
                        this.url_isolate_add_url = res.data.ret.result.url_isolate_add_url
                        this.data_loadok1 = res.data.ret.ok

                        this.show_hint1 = res.data.ret.result.LOAD_HINT1
                        this.show_hint2 = res.data.ret.result.LOAD_HINT2

                    }
                })
               
        },
        // 显示
        tan: function () {
            this.tanchu = true;
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },
    },
};
</script>

<style lang="less" scoped>
// 1
.main {
    display: flex;
    align-items: center;
    border: 2px solid #D2D7E6;

    // background: #f1f1f1;
    margin: 10px;

    text-align: left;
    //   margin-top: 20px;
}

.main p {
    height: 44px;
    width: 100%;
    display: flex;
    padding-left: 10px;
    font-size: 12px;

    align-items: center;
}

.main_text {
    margin-right: 6px;

    color: #0E2C5E;
}

.main .el-input {
    margin-right: 6px
}

.main .el-select {
    margin-right: 6px
}

.main {
    padding: 0;
}

/deep/ .el-input__icon {
    height: 24px;
    line-height: 24px;
}

@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";

/deep/ .el-tabs__nav {
    padding-left: 14px;
}
</style>
